import { Button, Icon, IconButton, styled, Theme, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { ReactNode, useEffect } from 'react';
import { Environment } from 'shared/environment';
import { useDrawerActions, useIsDrawerOpen, useIsDrawerMenuOpen } from 'shared/store/drawer';

interface ILayoutBaseDePaginaProps {
  titulo: string;
  titulo2?: string;
  TituloCrib?: string;
  botaoLog?: ReactNode;
  botaoTeste?: ReactNode;
  barraDeFerramentas?: ReactNode;
  drawerDeFiltros?: ReactNode;
}
export const LayoutBaseDePagina: React.FC<ILayoutBaseDePaginaProps> = ({ children, titulo,titulo2, TituloCrib, botaoLog, botaoTeste, barraDeFerramentas, drawerDeFiltros }) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();

  const drawerAction = useDrawerActions();
  const isDrawerOpen = useIsDrawerOpen();
  const isDrawerMenuOpen = useIsDrawerMenuOpen();

  const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
    open?: boolean;
  }>(({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingInline: theme.spacing(2),
    marginLeft: `${isDrawerMenuOpen ? Environment.TAMANHO_DO_DRAWER_MENU : 0}px`,
    boxSizing: 'border-box',
    height: `calc(100vh - ${theme.spacing(20)})`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${isDrawerMenuOpen ? Environment.TAMANHO_DO_DRAWER_LIST + Environment.TAMANHO_DO_DRAWER_MENU : Environment.TAMANHO_DO_DRAWER_LIST}px`,
    }),
  }));

  useEffect(() => {
    if (!drawerDeFiltros) {
      drawerAction.setIsDrawerOpen(false);
    }
  }, [drawerDeFiltros]);

  return (
    <>
      {drawerDeFiltros && (
        <>
          {drawerDeFiltros}
        </>
      )}
      <Main open={isDrawerOpen} color='yellow'>
        <Box height="100%" display="flex" flexDirection="column" gap={1}>
          <Box padding={1} display="flex" alignItems="center" gap={1} height={theme.spacing(smDown ? 6 : mdDown ? 8 : 12)} >
            {drawerDeFiltros && (
              <IconButton onClick={drawerAction.changeIsDrawerOpen}>
                {isDrawerOpen ? (<Icon>filter_alt_off</Icon>) : (<Icon>filter_alt</Icon>)}
              </IconButton>
            )}
            <Typography
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipses"
              variant={smDown ? 'h6' : mdDown ? 'h5' : 'h4'}
            >
              {        titulo}
            </Typography>
            
            <Typography
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              variant={smDown ? 'h1' : mdDown ? 'h2' : 'h3'}
              style={{ color: 'yellowgreen', fontWeight: 'bold' }}
            >
              
              {TituloCrib}
            </Typography>
            <Typography
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipses"
              variant={smDown ? 'h6' : mdDown ? 'h6' : 'h6'}
              style={{ color: '#AAAAAA', marginBottom: -16 , marginLeft:'50px',display: 'flex', alignItems: 'end'}}
            >
              {titulo2}
            </Typography>
            <Box flex={1} display="flex" justifyContent='end'>{botaoLog}

            </Box>


          </Box>

          <Box flex={1} overflow="auto">
            {children}
          </Box>
          {botaoTeste && (
            <Box sx={{ marginRight: '0.5rem' }} display="flex" justifyContent='end' >
              {botaoTeste}
            </Box>

          )}
          {barraDeFerramentas && (
            <Box >
              {barraDeFerramentas}
            </Box>

          )}

        </Box>
      </Main>
    </>

  );
};
